import { forwardRef } from 'react';

import {
  type NavLinkProps,
  NavLink,
  generatePath,
  useParams,
} from 'react-router-dom';

import { ListItemButton } from '../../../components/list';

import { MenuLinkContent } from './menu-link-content';
import type { MenuItemInternalProps } from './menu-link-types';

// fix: custom component to use react-router className function to set MUI selected state
// - Automatically applies classes to the link based on its active state.
// - Automatically applies `aria-current="page"` to the link when the link is active.
const NavLinkWithClasses = forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ to, end, className, children, ...rest }, ref) => (
    <NavLink
      ref={ref}
      to={to}
      end={end}
      className={({ isActive }) =>
        `${className} ${isActive ? 'Mui-selected' : ''}`
      }
      {...rest}
    >
      {children}
    </NavLink>
  ),
);

export const MenuLinkInternal = ({
  icon,
  title,
  routePrefix,
  segment,
  matchSegmentOnly = false,
  ...rest
}: MenuItemInternalProps) => {
  const params = useParams();
  const to = generatePath(`${routePrefix}${segment}`, params);

  return (
    <ListItemButton
      component={NavLinkWithClasses}
      to={to}
      end={matchSegmentOnly}
      {...rest}
    >
      <MenuLinkContent icon={icon} title={title} />
    </ListItemButton>
  );
};
